import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#f8f8f8',
    color100: '#f0f0f0',
    color200: '#e1e1e1',
    color300: '#b8b8b8',
    color400: '#8f8f8f',
    color500: '#666666',
    color600: '#555555',
    color700: '#444444',
    color800: '#2d2d2d',
    color900: '#171717'
  },
  default: {
    color50: '#695e8f',
    color100: '#53437e',
    color200: '#4d3b75',
    color300: '#45326a',
    color400: '#3d295e',
    color500: '#2e1a47',
    color600: '#26163b',
    color700: '#1f112f',
    color800: '#170d24',
    color900: '#0f0918'
  },
  accent: {
    color50: '#fbf7ec',
    color100: '#fadd86',
    color200: '#f8d157',
    color300: '#f6c638',
    color400: '#f5bc28',
    color500: '#f4af23',
    color600: '#f39d20',
    color700: '#f28d1d',
    color800: '#f0701a',
    color900: '#e65718'
  },
  positive: {
    color50: '#e8e6f2',
    color100: '#d1cde4',
    color200: '#bab3d7',
    color300: '#a39ac9',
    color400: '#7f73b4',
    color500: '#6457a5',
    color600: '#493d96',
    color700: '#353188',
    color800: '#2a2b7e',
    color900: '#152071'
  },
  negative: {
    color50: '#fecad3',
    color100: '#ef949b',
    color200: '#e56975',
    color300: '#f04153',
    color400: '#f6233a',
    color500: '#d50032',
    color600: '#c8002b',
    color700: '#ba001e',
    color800: '#7c0014',
    color900: '#3e000a'
  },
  special: {
    color50: '#ffe7df',
    color100: '#ffcebe',
    color200: '#ffb69e',
    color300: '#ff9d7d',
    color400: '#ff855d',
    color500: '#ff6a39',
    color600: '#ff4f11',
    color700: '#e64206',
    color800: '#d83a02',
    color900: '#bf2d00'
  }
};

const variant: ACPVariant = {
  id: 'www.mycontrolcard.com',
  productTitle: 'Control',
  productType: 'gpr',
  accessDomain: {
    subdomain: 'www',
    domain: 'mycontrolcard',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'control',
  legacyAcpBrandName: 'control',
  legacyLegosTheme: 'control',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: 'Control Card',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@mycontrolcard.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(866) 753-6324',
    phone: '8667536324',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: 'c1d5bf88-f890-46af-9e75-dad6bd2490a2',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: false,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: true
    },
    misc: {
      layoutComponentOverride: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#792560',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#009590',
      marketingSiteLinkText: 'Mycontrolcard.com',
      locationSearchMax: '25',
      iOSAppId: '485467914'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today.",
      copyrightStatement:
        'Netspend Corporation All rights reserved worldwide. Netspend is the federally registered U.S. service mark of Netspend Corporation All other trademarks and service marks belong to their owners.'
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
